import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'adpkd-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {  

  constructor(private router: Router) { }

  ngOnInit() {
  }

  openVariants() {
    this.router.navigateByUrl('/variants');
  }
}
